import React from "react";
import { object, string } from "prop-types";
import get from "lodash/get";
import { formatDistance } from "date-fns";
import { bn, enGB } from "date-fns/locale";

import { staticTexts } from "../../utils/Translate";

import "./liveText.m.css";

const LiveText = ({ story, lang = "en" }) => {
  const isClosed = get(story, ["metadata", "is-closed"], false);
  const lastPublishedAt = get(story, ["last-published-at"], null);

  const localeDetect = () => (lang === "bn" ? bn : enGB);

  return isClosed ? (
    <div styleName="live-text">
      {staticTexts(lang).liveText}{" "}
      {lastPublishedAt
        ? formatDistance(new Date(lastPublishedAt), new Date(), { locale: localeDetect(), addSuffix: true })
        : ""}
    </div>
  ) : (
    <div styleName="live-text open-blog ">{staticTexts(lang).liveText}</div>
  );
};

LiveText.propTypes = {
  story: object.isRequired,
  lang: string,
};

export default LiveText;
